// extracted by mini-css-extract-plugin
module.exports = {"header-wrapper":"header-wrapper__1vIYb","header":"header__ri0Yt","body":"body__Jl8Pa","main-form":"main-form__1E0kU"};